import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeSharedModule } from '../../font-awesome/font-awesome';
import { LabFacade } from '../../../views/labs/facade/lab.facade';
import { UserMgmtFacade } from '../../../views/user-management/facade/user-mgmt.facade';
import { ILab } from '../../../views/labs/models/Labs';
import { isLabInactive } from '../../utils/lab-status';

// Tells the user their active lab is inactive, on every lab-scoped page rather
// than only on the lab detail screen. Without it the state is only discoverable
// by drilling into projects or sequences, or by noticing that an action button
// has quietly gone missing.
@Component({
  selector: 'app-lab-inactive-banner',
  imports: [CommonModule, FontAwesomeSharedModule],
  templateUrl: './lab-inactive-banner.component.html',
})
export class LabInactiveBannerComponent {
  private readonly labFacade = inject(LabFacade);
  private readonly userMgmtFacade = inject(UserMgmtFacade);

  // Resolved against the fetched lab list, not the persisted selection: the
  // store copy survives across sessions and can be a status behind, and the
  // memberships on /me carry no status at all. Until the list arrives the
  // banner stays hidden rather than announcing a stale state.
  inactiveLab = computed<ILab | null>(() => {
    if (this.userMgmtFacade.getMeUserSignal()?.is_platform_admin === true) return null;

    const selectedId = this.labFacade.selectedLabSignal()?.id;
    if (selectedId == null) return null;

    const lab = this.labFacade.labListSignal().find((candidate) => candidate.id === selectedId);
    return lab && isLabInactive(lab) ? lab : null;
  });
}
